import uniqBy from "lodash.uniqby";
import React from "react";

import { IgButton, IgPaper, IgTypography } from "@intelligems/ig-theme";
import {
  AgencySubscriptionDto,
  AgencySubscriptionItemDto,
  FullAgencyDto,
} from "@intelligems/ig-types";
import { Grid, Paper, useTheme } from "@mui/material";
import { SubscriptionDetailsHeader } from "@src/features/admin/components/SubscriptionDetailsHeader";
import { AgencyProductAccordion } from "@src/features/admin/pages/agencies/components/Expansions/AgenciesPanel/SubscriptionsTab/AgencySubscriptionPanel/AgencyProductAccordion/AgencyProductAccordion";
import { useDispatch } from "@src/store";
import { setDrawer } from "@src/store/slices/drawers";

interface AgencySubscriptionPanelProps {
  agency: FullAgencyDto;
  subscription: AgencySubscriptionDto;
}

export const AgencySubscriptionPanel = ({
  subscription,
  agency,
}: AgencySubscriptionPanelProps) => {
  const products = uniqBy(subscription.items, (_) => _.product.stripeProductId);
  const dispatch = useDispatch();
  const theme = useTheme();
  return (
    <IgPaper
      sx={{
        backgroundColor: theme.igBackgroundColors.baseLightLow,
        padding: "15px 20px 20px 20px",
      }}
    >
      <Grid container item direction={"column"} rowSpacing={2}>
        <Grid item>
          <SubscriptionDetailsHeader
            viewCharges={null}
            v1={false}
            stripeSubscriptionScheduleId={
              subscription.stripeSubscriptionScheduleId
            }
            stripeSubscriptionId={subscription.stripeSubscriptionId}
            autoScale={subscription.stripeSubscriptionLinks.some(
              (sl) => sl.autoScale
            )}
            isBalanceExceeded={subscription.stripeSubscriptionLinks.some(
              (sl) => sl.isBalanceExceeded
            )}
            status={subscription.status}
            customer={
              agency.customers.find(
                (cust) =>
                  cust.stripeCustomerId === subscription.stripeCustomerId
              ) || undefined
            }
          />
        </Grid>
        <Grid container item direction={"column"} rowSpacing={2}>
          <Grid item>
            <IgTypography variant={"h3"} sx={{ fontWeight: 600 }}>
              Subscription Products:
            </IgTypography>
          </Grid>
          {products.map((item: AgencySubscriptionItemDto) => {
            return (
              <Grid item key={item.product.stripeProductId}>
                <AgencyProductAccordion
                  item={item}
                  subscription={subscription}
                  agency={agency}
                />
              </Grid>
            );
          })}
        </Grid>
        <Grid container item justifyContent={"end"}>
          <Grid item>
            <IgButton
              variant={"outlined"}
              onClick={() =>
                dispatch(
                  setDrawer({
                    type: "modifySubscription",
                    open: true,
                    usages: null,
                    agencyId: agency.id,
                    orgs: agency.organizationAgencyLinks.map((oal) => ({
                      id: oal.organization.id,
                      shopId: oal.organization.shopId,
                    })),
                    stripeSubscriptionId: subscription.stripeSubscriptionId,
                    subscriptionLinkIds:
                      subscription.stripeSubscriptionLinks.map(
                        (link) => link.id
                      ),
                  })
                )
              }
            >
              Modify Subscription
            </IgButton>
          </Grid>
        </Grid>
      </Grid>
    </IgPaper>
  );
};
